import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { StoreManagementDeliveryStoreService } from '@/services/StoreManagement/DeliveryStores/StoreManagementDeliveryStoreService';

export type StoreManagementDeliveryStoreSearchListParams = {
  limit: number;
  currentPage: number;
  storeName: string;
  authStoreIds: number[];
  storeState: string;
  pendingReasons: string[];
};

export type DeliveryStore = {
  id: number;
  store_name: string;
  store_state: string;
  pending_reason: string;
  delivery_service_id: number;
  auth_store_id: number;
  auth_store_name: string;
  updated_at: string;
};

export type StoreManagementDeliveryStoreSearchListResponse = {
  delivery_stores: DeliveryStore[];
  count: number;
};

export const useStoreManagementDeliveryStoreSearchList = async (
  params: StoreManagementDeliveryStoreSearchListParams
): Promise<StoreManagementDeliveryStoreSearchListResponse> => {
  const storeManagementStoreService = new StoreManagementDeliveryStoreService(
    getClient()
  );
  try {
    return await storeManagementStoreService.searchList(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
